Customer.Dashboard ||= {}

class Customer.Dashboard.SummarySelectionView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/header/summary_selection']

  initialize: (options) ->
    super(options)
    @allSelection = "NONE"

  render: ->
    @$el.html(@template())
    @$el.find('#summary-checkbox').on 'click', (event) =>
      @selectAllLoaded(event)
    @

  selectAllLoaded: (event) =>
    @_keepCustomerSessionAlive()
    @clickSelectAll()
    @trigger('summary:select:all', @isSelectAllChecked())

  isSelectAllChecked: ->
    return @allSelection == "ALL"

  isSelectPartialChecked: ->
    return @allSelection == "PARTIAL"

  isSelectNoneChecked: ->
    return @allSelection == "NONE"

  unselect: () ->
    @$el.find('#summary-checkbox').prop('checked', false)

  unselectAll: () ->
    @unselect()
    @trigger('summary:select:all', false)

  clickSelectAll: ->
    if @isSelectNoneChecked()
      @toggleStates('#none-selected', '#all-selected', "ALL")
    else if @isSelectAllChecked()
      @toggleStates('#all-selected', '#none-selected', "NONE")
      @trigger('summary:unselect:not:loaded')
    else if @isSelectPartialChecked()
      @toggleStates('#partial-selected', '#none-selected', "NONE")

  selectNone: ->
    @toggleStates(@currentStateSelector(), '#none-selected', "NONE")

  selectPartially: ->
    @toggleStates(@currentStateSelector(), '#partial-selected', "PARTIAL")

  selectAll: ->
    @toggleStates(@currentStateSelector(), '#all-selected', "ALL")

  selectNotLoaded: ->
    @selectAll()
    @trigger('summary:select:all', @isSelectAllChecked())

  toggleStates: (hideElement, showElement, state) ->
    @$el.find(hideElement).addClass('d-none')
    @$el.find(showElement).removeClass('d-none')
    @allSelection = state

  currentStateSelector: ->
    state = @allSelection.toLowerCase()
    return '#' + state + '-selected'

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
